import styled from '@emotion/styled'

export default styled.h2`
  font-size: 28px;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: 900;
  line-height: 1.1;
`
